import UltMeta, { Meta } from "./UltMeta/index";
/**
 * 激活码状态枚举
 */
class SupportOnline extends UltMeta {
    SUPPORT = new Meta(1, "支持");
    NOT_SUPPORT = new Meta(0, "不支持");
}

export const SUPPORT_ONLINE = new SupportOnline();